import formatOreToKroner from '../../../lib/formatOreToKroner';

export function validateAmount({ amountOre, freightOre = 0, maxAmountOre }) {
    if (!amountOre || amountOre < 0) {
        return {
            invalid: true,
            message: 'Du må oppgi en pris.',
        };
    }

    if (amountOre + freightOre > maxAmountOre) {
        return {
            invalid: true,
            message: `Pris (inkludert frakt) kan ikke overstige ${formatOreToKroner(
                maxAmountOre
            )}.`,
        };
    }

    return {
        invalid: false,
    };
}

export function validateFreight({ buyerPaysFreight, freightOre }) {
    if (!buyerPaysFreight) {
        return { invalid: false };
    }

    const isValid = typeof freightOre === 'number' && freightOre >= 0;

    return {
        invalid: !isValid,
        message: 'Du må oppgi frakt.',
    };
}

export function validateAcceptTerms({ termsAccepted }) {
    return {
        invalid: !termsAccepted,
        message: 'Du må bekrefte at du forstår at avtalen er bindende.',
    };
}



// WEBPACK FOOTER //
// ./safeTrade/buyer/agreement/enterAmountValidator.js